import t from 'tcomb';
import Deal from './Deal';
import Amount from './Amount';
import UUID from './UUID';
import Int from './Int';

const Registered_State = t.enums.of(['virgin', 'sinner']);

const Runtime = t.struct({
  price: t.maybe(Amount),
  delta: t.maybe(Int),
  bonus: t.maybe(Amount),
  is_sold_out: t.Bool,
  is_max_items_overflow: t.Bool,
  payments_overflow: t.maybe(UUID),
  status: t.maybe(Registered_State),
  best: t.maybe(Deal),
  lasts: t.list(Deal)
}, 'Runtime');

module.exports = Runtime;




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/Runtime.js
 **/